import { createSlice } from '@reduxjs/toolkit';
import { requestStatusConstants } from '../../../Integration/integration-util';

const initialState = {
  poiPackagesList: {},
  status: requestStatusConstants.INITIAL,
  putCustomPOIStatus: requestStatusConstants.INITIAL,
  putCustomPOIResponse: {},
  putCustomPOIError: {},
};

const oohSlice = createSlice({
  name: 'ooh',
  initialState,
  reducers: {
    fetchPoiPackagesListAction(state, action) {
      state.poiPackagesList = initialState.poiPackagesList;
      state.status = requestStatusConstants.PROGRESS;
    },
    fetchPoiPackagesListSuccessAction(state, action) {
      state.poiPackagesList = action.payload;
      state.status = requestStatusConstants.SUCCESS;
    },
    fetchPoiPackagesListFailedAction(state, action) {
      state.poiPackagesList = initialState.poiPackagesList;
      state.status = requestStatusConstants.FAILED;
    },
    resetPoiPackagesListAction(state, action) {
      state.poiPackagesList = initialState.poiPackagesList;
      state.status = initialState.status;
    },

    putCustomPOIAction(state, action) {
      state.putCustomPOIStatus = requestStatusConstants.PROGRESS;
    },
    putCustomPOISuccessAction(state, action) {
      state.putCustomPOIResponse = action.payload;
      state.putCustomPOIStatus = requestStatusConstants.SUCCESS;
    },
    putCustomPOIFailedAction(state, action) {
      state.putCustomPOIStatus = requestStatusConstants.FAILED;
      state.putCustomPOIError = action.payload?.response?.data?.message;
    },
    resetPutCustomPOI(state, action) {
      state.putCustomPOIResponse = initialState.putCustomPOIResponse;
      state.putCustomPOIStatus = initialState.putCustomPOIStatus;
    },
  },
});

export const {
  fetchPoiPackagesListAction,
  fetchPoiPackagesListSuccessAction,
  fetchPoiPackagesListFailedAction,
  resetPoiPackagesListAction,
  putCustomPOIAction,
  putCustomPOISuccessAction,
  putCustomPOIFailedAction,
  resetPutCustomPOI,
} = oohSlice.actions;
export default oohSlice.reducer;
